/** Zod schemas for reviewer-candidate API contract — GH-247 */

import { z } from 'zod'

export const memberRoleSchema = z.enum(['admin', 'editor', 'viewer', 'agent'])

export const reviewerCandidateSchema = z.object({
  userId: z.string(),
  displayName: z.string(),
  email: z.string().email(),
  role: memberRoleSchema,
  workload: z.number().int().min(0),
})

export const reviewerCandidateListResponseSchema = z.object({
  items: z.array(reviewerCandidateSchema),
})

export const reviewerCandidatesQuerySchema = z.object({
  q: z.string().optional(),
  // Accept any positive integer from the client; service layer caps at 50 (no 400 for large values).
  limit: z.coerce.number().int().min(1).default(20),
})
